import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../src/Context/AuthContext';
import { Link } from 'react-router-dom';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const ForgotUsernamePage = ({ portalSettings }) => {
    //State Variables
    const { login, isAuthenticated } = useAuth();
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Forgot Username`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    //If authenticated - Redirect
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const queryParams = new URLSearchParams({ userEmail: email });
            const res = await fetch(`${apiURL}/account/forgot-username?${queryParams.toString()}`, {
                method: 'POST',
                credentials: 'include'
            });

            if (!res.ok) {
                const errorData = await res.json().catch(() => ({}));
                setError(errorData.message || 'Unable to process request.');
                return;
            }

            setSubmitted(true);
        } catch (err) {
            console.error('Forgot password error:', err);
            setError('Unable to send reset instructions. Try again later.');
        }
    };

    return (
        <div className="auth-page">
            <EmptyHeader />
            <EmptyHeader />
            <EmptyHeader />
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Forgot Username</h2>
                {submitted ? (
                    <p>If an account exists, the username was sent to your email.</p>
                ) : (

                <form className="baseForm" onSubmit={handleSubmit}>
                    <label className="baseLabel">Email</label>
                    <input className="baseInput" value={email} onChange={(e) => setEmail(e.target.value)} required />

                    {error && <p className="text-danger">{error}</p>}


                    <button className="baseButton" type="submit">Submit</button>
                </form>
                
                )}
                <div className="auth-links">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotUsernamePage;
